import React from "react";
import {Link} from "react-router-dom";
import PillveryButton from "../FormComponents.js/PillveryButton";

export default function Breadcrumb({label, hasRoutes, routes = [], createBtn, createBtnLabel, showCreateModal, customBtn, customBtnLabel, customBtnCallback}) {
    return (
        <div className="row print-hide">
            <div className="col-md-12 grid-margin">
                <div className="mt-3 d-flex justify-content-between flex-wrap">
                    <div className="d-flex align-items-center dashboard-header flex-wrap mb-3 mb-sm-0">
                        <h5 className=" mr-4 mb-0 font-weight-bold">{ label }</h5>
                        {
                            hasRoutes ? (
                                <div className="d-flex align-items-baseline dashboard-breadcrumb">
                                    <p className="text-muted mb-0 mr-1 hover-cursor">
                                        <Link to="/dashboard">
                                            Dashboard
                                        </Link>
                                    </p>
                                    {
                                        routes.map(route => (
                                            <>
                                                <span className="mdi mdi-chevron-right mr-1 text-muted"></span>
                                                <p className="text-muted mb-0 mr-1 hover-cursor">
                                                    {
                                                        !route.route?(
                                                            <span class="">
                                                                { route.label }
                                                            </span>
                                                        ): (
                                                            <Link to={ route.route} >
                                                                { route.label }
                                                            </Link >
                                                        )
                                                    }
                                                </p>
                                            </>
                                        ))
                                    }
                                </div>
                            ) : null
                        }

                    </div>
                    {/*<div className="d-flex">*/}
                    {/*    <div className="btn-group mr-3">*/}
                    {/*        <button type="button" className="btn btn-primary">02 Aug 2019</button>*/}
                    {/*        <button type="button"*/}
                    {/*                className="btn btn-primary dropdown-toggle dropdown-toggle-split"*/}
                    {/*                id="dropdownMenuSplitButton1" data-toggle="dropdown"*/}
                    {/*                aria-haspopup="true" aria-expanded="false">*/}
                    {/*            <span className="sr-only">Toggle Dropdown</span>*/}
                    {/*        </button>*/}
                    {/*        <div className="dropdown-menu" aria-labelledby="dropdownMenuSplitButton1">*/}
                    {/*            <a className="dropdown-item" href="#">Sept 2019</a>*/}
                    {/*            <a className="dropdown-item" href="#">Oct 2019</a>*/}
                    {/*            <a className="dropdown-item" href="#">Nov 2019</a>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    <button className="btn bg-white border d-none d-sm-block">Download Report</button>*/}
                    {/*</div>*/}
                    
                    {
                        createBtn ? (
                            <PillveryButton
                                label   = { "+ Add " + createBtnLabel}
                                class   = "btn btn-success add-items-btn pillvery-border-radius"
                                onClick = { showCreateModal }
                                style   = {{width: "fit-content", minWidth: 160,     marginTop: 5, marginRight: 0}}
                            />
                        ) : null
                    }
                    {
                        customBtn ? (
                            <PillveryButton
                                label   = {customBtnLabel}
                                class   = "btn btn-success add-items-btn pillvery-border-radius print-hide"
                                onClick = { customBtnCallback }
                                style   = {{width: "fit-content", minWidth: 160, marginTop: 5, marginRight: 0}}
                            />
                        ) : null
                    }
                </div>
            </div>
        </div>
    )
}